import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Clock, Search, Globe, Filter, TrendingUp, Calendar } from 'lucide-react';

export default function VisitorHistoryView({ globalSearch = '' }) {
  const [searchQuery, setSearchQuery] = useState(globalSearch);

  const historyLogs = [];

  return (
    <div className="p-6 space-y-6 font-sans bg-[#F8F8F6] min-h-screen text-slate-800">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-white p-5 rounded-2xl border border-[#ECECEC] shadow-xs">
        <div>
          <h1 className="text-xl font-black text-slate-900 tracking-tight">Visitor History</h1>
          <p className="text-xs text-slate-500 mt-1">Riwayat histori lalu lintas pengunjung anonym di website Satala Dermatech.</p>
        </div>

        <div className="relative w-full sm:w-72">
          <Search className="absolute left-3 top-2.5 w-3.5 h-3.5 text-slate-400" />
          <Input 
            placeholder="Cari ID, halaman, sumber..." 
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            className="pl-8 h-9 text-xs bg-slate-50 border-[#ECECEC] rounded-xl"
          />
        </div>
      </div>

      <Card className="bg-white border-[#ECECEC] shadow-xs overflow-hidden">
        <div className="p-4 border-b border-[#ECECEC]">
          <h3 className="font-bold text-sm text-slate-900">Histori Pengunjung (Archive)</h3>
        </div>
        <table className="w-full text-left text-xs">
          <thead className="bg-[#FAF8F5] text-slate-600 font-bold border-b border-[#ECECEC]">
            <tr>
              <th className="py-3 px-4">Visitor ID</th>
              <th className="py-3 px-4">Waktu Kunjungan</th>
              <th className="py-3 px-4">Halaman Terbuka</th>
              <th className="py-3 px-4">Sumber Iklan</th>
              <th className="py-3 px-4">Perangkat</th>
              <th className="py-3 px-4">Lokasi</th>
              <th className="py-3 px-4 font-mono">Durasi</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#ECECEC]">
            {historyLogs.map(l => (
              <tr key={l.id} className="hover:bg-[#FAF8F5]">
                <td className="py-3 px-4 font-mono font-bold text-[#A97838]">{l.id}</td>
                <td className="py-3 px-4 text-slate-500 font-mono text-[11px]">{l.date}</td>
                <td className="py-3 px-4 font-mono text-slate-800 font-bold">{l.page}</td>
                <td className="py-3 px-4 font-semibold text-blue-600">{l.source}</td>
                <td className="py-3 px-4 text-slate-600">{l.device}</td>
                <td className="py-3 px-4 font-semibold text-slate-800">{l.location}</td>
                <td className="py-3 px-4 font-mono text-slate-500">{l.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
